


class CustomBundlePage
extends HTMLElement {

    constructor (){

        super ()

        this.quizData = this._getQuizData();
        this.validKeywords = ["Octane_Name", "Octane_Routine_ja_nein", "SKIN_CONCERN_1", "SKIN_CONCERN_2", "SKIN_CONCERN_3", "BEAU_SKIN_TYPE", "BEAU_Sensitivity", "Octane_Ausbrueche_wieoft", "Octane_Ausbrueche_wo", "Octane_Skintone", "Octane_Stress", "Octane_Essensgewohnheiten", "Octane_Sonnencreme", "Octane_Makeup", "Octane_Wasser", "Octane_Alter", "Octane_Sport", "Octane_Geschlecht", "Octane_Schwanger"];

        this.config = this.#loadConfig()

        this._buildPage();
    }

    #loadConfig (){

        const element = document
            .querySelector(`#Quiz-Config`)

        const json = element.textContent

        const data = JSON.parse(json)

        return data
    }

    _getQuizData() {
      let _quizData;
      if (this._getCookie('analyseData') === '') {
        _quizData = this._getCookie('custom_product_data');
      } else {
        _quizData = JSON.parse(this._getCookie('analyseData'));
      }
      return _quizData;
    }
    _getCookie(name) {
      let cookieName = name + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(cookieName) === 0) {
              return c.substring(cookieName.length, c.length);
          }
      }
      return "";
    }
    _setCookie(name, value, days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      let expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    async _getData (){

        const url = this.config.Endpoint

        const response = await fetch(url,{
            method: 'POST',
            body: this.quizData
        })

        const json = await response.json()

        return json;
    }

    async _buildPage() {
      if (this.quizData === '') {
        console.log("No Quiz Data");
        return;
      }

      const finalData = await this._getData(this.quizData);

      if (this._getCookie('dataAddedToCart') !== finalData["hash"]) {
        this._addProductsToCart(finalData["selectedProducts"]);
        this._setCookie('dataAddedToCart', finalData["hash"], 1);
      }

      document.dispatchEvent(new CustomEvent("bundlePage:updateIngredients", {
        bubbles: true,
        detail: {
          ingredients: finalData["dynamicIngredients"],
          ingredientImages: finalData["ingredientImages"],
          ingredientShortDescriptions: finalData["ingredientShortDescriptions"],
          ingredientDescriptions: finalData["ingredientDescriptions"]
        }
      }));

      document.dispatchEvent(new CustomEvent("bundlePage:updateFocusHeader", {
        bubbles: true,
        detail: {
          quiz_data: this.quizData
        }
      }));

      if (finalData["forbiddenProducts"] && finalData["forbiddenProducts"].length > 0) {
        finalData["forbiddenProducts"].forEach(product => {
          const element = this.querySelector(`.bundleProduct--section[data-variant-id="${product}"]`);
          if (element != null) {
            element.hidden = true;
          }
        });
      }

      const bundleProducts = this.querySelectorAll(".bundleProduct--section:not([hidden])");
      let selectedIndex = 1;
      let unselectedIndex = 1;
      bundleProducts.forEach(product => {
        if (finalData["selectedProducts"].includes(product.dataset.variantId)) {
          product.classList.add("selected");
          product.setAttribute("data-order-index", selectedIndex);
          selectedIndex++;
        } else {
          product.classList.remove("selected");
          product.setAttribute("data-order-index", unselectedIndex);
          unselectedIndex++;
        }
      });

      if (selectedIndex == 2) {
        document.querySelector(".bundleProduct--section.selected").setAttribute("data-order-index", 0);
      }
      if (unselectedIndex == 2) {
        document.querySelector(".bundleProduct--section:not(.selected)").setAttribute("data-order-index", 0);
      }

      const unselectedProductHeader = document.querySelector(".unselectedBundleProducts--header");
      if (unselectedIndex == 1 && unselectedProductHeader != undefined) {
        unselectedProductHeader.classList.add("hidden");
      }
    }
    async _addProductsToCart(selectedProducts) {
      // Vorbereiten der sectionsToBundle basierend auf selectedProducts
      const sectionsToBundle = selectedProducts.map(id => `variant_${id}`);
      sectionsToBundle.push("cart-information-drawer");

      const quizDataObject = JSON.parse(this.quizData);

      const formData = new FormData();
      for(let i = 0; i < selectedProducts.length; i++) {
        formData.append(`items[${i}][id]`, selectedProducts[i]);
        formData.append(`items[${i}][quantity]`, 1);
        if (i == 0) {
          formData.append(`items[${i}][properties][__custom-product]`, "true");
          for (let key of this.validKeywords) {
            let inputValue = "undefined";
            if (quizDataObject[key] != undefined) {
              inputValue = quizDataObject[key];
            }
            formData.append(`items[${i}][properties][__${key}]`, inputValue);
          }
        }
      }
      formData.set("sections", "cart-information-drawer");

      // Durchführen des Fetch-Aufrufs
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest' // Benötigt von Shopify zur Bestandsprüfung
        },
        body: formData
      });

      // Verarbeiten der Antwort
      const responseJson = await response.json();

      if (response.ok) {
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];

        // Auslösen des 'variant:add' Events, wenn die Antwort erfolgreich war
        this.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
            blockCartDrawerOpening: true,
            cart: cartContent // Hier könnte die Logik zur Erhaltung des Warenkorbinhalts erforderlich sein
          }
        }));

        // Auslösen des 'cart:change' Events
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
      } else {
        // Auslösen des 'cart:error' Events im Fehlerfall
        this.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"]
          }
        }));
      }
    }
}


window.customElements.define(
    'custom-bundle-page' ,
    CustomBundlePage
)
